module.exports = __webpack_public_path__ + "static/media/CAN events Zurich.1dcf9e74.jpg";